const removeTrailingSlash = (pathName: string): string => {
  if (pathName === '/') return pathName;

  return pathName?.replace(/\/$/, '');
};

export { removeTrailingSlash };
